'use strict';

angular.module('mobile-apps')
	.directive('fastListViewport',[function() {
		return {
			restrict: 'A',
			controller: ['$scope', '$element', function (scope, element) {
				this.scope = scope;
				this.element = element;
			}]
		};
	}]);
